// ============================================================
// number-formatting.ts  — Knockout カスタムバインディング
// ============================================================

ko.bindingHandlers['number'] = {
    update(
        element: HTMLElement,
        valueAccessor: () => any,
        allBindingsAccessor: () => any,
    ) {
        const defaults = (ko.bindingHandlers['number'] as any).defaults;
        const aba = allBindingsAccessor();
        const unwrap = ko.utils.unwrapObservable;

        let value: number = unwrap(valueAccessor()) || valueAccessor();
        const separator: string = unwrap(aba.separator) || defaults.separator;
        const decimal: string = unwrap(aba.decimal) || defaults.decimal;
        const precision: number = unwrap(aba.precision) || defaults.precision;
        const symbol: string = unwrap(aba.symbol) || defaults.symbol;
        const after: boolean = unwrap(aba.after) || defaults.after;

        value = parseFloat(String(value)) || 0;
        if (precision > 0) {
            value = parseFloat(value.toFixed(precision));
        }

        const numarray = value.toString().split('.');
        let result = '';
        for (let i = 0; i < numarray.length; i++) {
            result +=
                i === 0
                    ? numarray[i].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + separator)
                    : decimal + numarray[i];
        }
        result = after ? result + symbol : symbol + result;

        // allBindingsAccessor を any にキャストして型エラーを回避
        (ko.bindingHandlers['text'] as any).update(
            element,
            () => result,
            allBindingsAccessor,
            null,
            null,
        );
    },
    defaults: {
        separator: ',',
        decimal: '.',
        precision: 0,
        symbol: '',
        after: false,
    },
};
